const n = "{{currentTime}} sou {{duration}}", t = "Rezilta rechèch {{current}} sou {{total}}", o = "Nou pa jwenn rezilta", s = "{{count}} rezilta nou jwenn", e = "{{count}} rezilta twouve", A = 'Jwe apati de $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) ak $t(SECONDS, { "count": {{seconds}} }).', a = 'Jwe apati de $t(MINUTES, { "count": {{minutes}} }) ak $t(SECONDS, { "count": {{seconds}} }).', c = 'Jwe apati de $t(SECONDS, { "count": {{seconds}} }).', E = "Erè pandan w ap anrejistre chanjman yo nan transkripsyon an.", T = "Liy transkripsyon nan {{time}}. Kontni an se: {{text}}.", S = 'Kontenè liy transkripsyon. Gen $t(TRANSCRIPT_LINES, { "count": {{count}} }) andedan kontenè sa a. Pou navige nan kontenè sa a, itilize flèch anba a.', _ = "Anrejistre chanjman yo...", i = "Chanjman yo anrejistre nan transkripsyon an.", R = "Bouton pou mete soutit yo ajou disponib kounye a.", N = "Aksyon", O = "Ajoute anotasyon nan {{time}}", I = "Ajoute kesyon nan {{time}}", C = "Anotasyon", P = "Oto", r = "Otomatik ({{quality}})", u = "Retounen", U = "Soutit", L = "Langaj Soutit", y = "Jere Soutit", D = "Efase {{language}}", l = "Gwosè lèt", p = "Lang Soutit: {{language}}", M = "{{language}} (otomatik)", k = "Efase Rechèch", m = "Fèmen", h = "Kòmantè", d = "Kontinye", G = "Diminye Vitès Repwodiksyon", Y = "Diminye Volim de {{percent}}%", V = "Flèch Anba", j = "Fèmen Editè Transkripsyon an", w = "Mizajou Soutit yo", g = "Erè!", K = "Anrejistreman...", H = "Anrejistre!", F = "Modifye Transkripsyon", z = "Tèks la pa ka vid!", B = "Plen Ekran", v = "{{count}} èdtan", J = "{{count}} èdtan", f = "Ogmante Vitès Repwodiksyon", W = "Ogmante Volim de {{percent}}%", $ = "Ranvèse koulè", Q = "Ale nan pousantaj espesifik (1-10%, 2-20%, elatriye)", b = "Ale nan Demare", q = "Aksyon pou {{title}}", x = "Rakousi Klavye", Z = "Langaj", X = "Flèch Agoch", nn = "Meni Prensipal", tn = "{{count}} minit", on = "{{count}} minit", sn = "Silans", en = "An Silans", An = "Pwochen Lang Soutit", an = "Pwochen rezilta rechèch la", cn = "Fèmen", En = "Anlè", Tn = "Ouvri anotasyon a {{time}}", Sn = "Ouvri quiz konplete a {{time}}", _n = "Ouvri quiz a {{time}}", Rn = "Poz", Nn = "Jwe", On = "Vitès Repwodiksyon", In = "Vitès Repwodiksyon: {{speed}}x", Cn = "Ansyen Lang Soutit", Pn = "Rezilta rechèch anvan", rn = "Kalite", un = "Meni Kalite", Un = "Rejwe", Ln = "Reinisyalize Vitès Repwodiksyon", yn = "Flèch Adwat", Dn = "Chèche nan transkripsyon an", ln = "{{count}} segonn", pn = "{{count}} segonn", Mn = "Chèche pa dèyè: {{seconds}} segonn", kn = "Chèche pa devan: {{seconds}} segonn", mn = "Paramèt", hn = "Rakousi", dn = "Detay medya ak zouti", Gn = "Espas", Yn = "Meni vitès repwodiksyon", Vn = "Kòmanse defilman otomatik", jn = "Chanje Soutit", wn = "Mete sou Silans", gn = "Chanje Jwe/Poz", Kn = "se liy {{count}} nan transkripsyon an", Hn = "se liy {{count}} nan transkripsyon yo", Fn = "Chajman transkripsyon...", zn = "Nou pa t ka chaje transkripsyon an.", Bn = "Opsyon Transkripsyon", vn = "Re eseye", Jn = "Transkripsyon pa disponib", fn = "Flèch Monte", Wn = "Paramèt videyo", $n = "Volim", Qn = "Volim: {{volume}}%", bn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: o,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: e,
  A11Y_TIMESTAMP_JUMP_HOURS: A,
  A11Y_TIMESTAMP_JUMP_MINUTES: a,
  A11Y_TIMESTAMP_JUMP_SECONDS: c,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: T,
  A11Y_TRANSCRIPT_LINES: S,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: i,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: R,
  ACTION: N,
  ADD_ANNOTATION_AT: O,
  ADD_QUESTION_AT: I,
  ANNOTATIONS: C,
  AUTO: P,
  AUTO_QUALITY: r,
  BACK: u,
  CAPTIONS: U,
  CAPTIONS_LANGUAGE: L,
  CAPTIONS_MANAGE: y,
  CAPTION_DELETE: D,
  CAPTION_FONT_SIZE: l,
  CAPTION_LANGUAGE: p,
  CAPTION_LANGUAGE_AUTOMATIC: M,
  CLEAR_SEARCH: k,
  CLOSE: m,
  COMMENTS: h,
  CONTINUE: d,
  DECREASE_PLAYBACK_SPEED: G,
  DECREASE_VOLUME: Y,
  DOWN_ARROW: V,
  EDIT_CLOSE: j,
  EDIT_CONFIRM: w,
  EDIT_ERROR: g,
  EDIT_SAVING: K,
  EDIT_SUCCESS: H,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: z,
  FULLSCREEN: B,
  HOURS: v,
  HOURS_other: J,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: W,
  INVERT_COLORS: $,
  JUMP_TO_PERCENTAGE: Q,
  JUMP_TO_START: b,
  KEBAB_MENU: q,
  KEYBOARD_SHORTCUTS: x,
  LANGUAGE: Z,
  LEFT_ARROW: X,
  MAIN_MENU: nn,
  MINUTES: tn,
  MINUTES_other: on,
  MUTE: sn,
  MUTED: en,
  NEXT_CAPTION_LANGUAGE: An,
  NEXT_HIT: an,
  OFF: cn,
  ON_TOP: En,
  OPEN_ANNOTATION_AT: Tn,
  OPEN_COMPLETED_QUIZ_AT: Sn,
  OPEN_QUIZ_AT: _n,
  PAUSE: Rn,
  PLAY: Nn,
  PLAYBACK_SPEED: On,
  PLAYBACK_SPEED_MESSAGE: In,
  PREVIOUS_CAPTION_LANGUAGE: Cn,
  PREVIOUS_HIT: Pn,
  QUALITY: rn,
  QUALITY_MENU: un,
  REPLAY: Un,
  RESET_PLAYBACK_SPEED: Ln,
  RIGHT_ARROW: yn,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Dn,
  SECONDS: ln,
  SECONDS_other: pn,
  SEEK_BACKWARD: Mn,
  SEEK_FORWARD: kn,
  SETTINGS: mn,
  SHORTCUT: hn,
  SIDEBAR: dn,
  SPACE: Gn,
  SPEED_MENU: Yn,
  START_AUTOSCROLL: Vn,
  TOGGLE_CAPTIONS: jn,
  TOGGLE_MUTED: wn,
  TOGGLE_PLAY_PAUSE: gn,
  TRANSCRIPT_LINES: Kn,
  TRANSCRIPT_LINES_other: Hn,
  TRANSCRIPT_LOADING: Fn,
  TRANSCRIPT_LOAD_ERROR: zn,
  TRANSCRIPT_OPTIONS: Bn,
  TRANSCRIPT_RETRY: vn,
  TRANSCRIPT_UNAVAILABLE: Jn,
  UP_ARROW: fn,
  VIDEO_SETTINGS: Wn,
  VOLUME: $n,
  VOLUME_VALUE: Qn
};
export {
  n as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  o as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  e as A11Y_SEARCH_RESULTS_FOUND_other,
  A as A11Y_TIMESTAMP_JUMP_HOURS,
  a as A11Y_TIMESTAMP_JUMP_MINUTES,
  c as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  T as A11Y_TRANSCRIPT_LINE,
  S as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  i as A11Y_TRANSCRIPT_SUCCESS,
  R as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  O as ADD_ANNOTATION_AT,
  I as ADD_QUESTION_AT,
  C as ANNOTATIONS,
  P as AUTO,
  r as AUTO_QUALITY,
  u as BACK,
  U as CAPTIONS,
  L as CAPTIONS_LANGUAGE,
  y as CAPTIONS_MANAGE,
  D as CAPTION_DELETE,
  l as CAPTION_FONT_SIZE,
  p as CAPTION_LANGUAGE,
  M as CAPTION_LANGUAGE_AUTOMATIC,
  k as CLEAR_SEARCH,
  m as CLOSE,
  h as COMMENTS,
  d as CONTINUE,
  G as DECREASE_PLAYBACK_SPEED,
  Y as DECREASE_VOLUME,
  V as DOWN_ARROW,
  j as EDIT_CLOSE,
  w as EDIT_CONFIRM,
  g as EDIT_ERROR,
  K as EDIT_SAVING,
  H as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  z as EDIT_VALIDATION_ERROR,
  B as FULLSCREEN,
  v as HOURS,
  J as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  W as INCREASE_VOLUME,
  $ as INVERT_COLORS,
  Q as JUMP_TO_PERCENTAGE,
  b as JUMP_TO_START,
  q as KEBAB_MENU,
  x as KEYBOARD_SHORTCUTS,
  Z as LANGUAGE,
  X as LEFT_ARROW,
  nn as MAIN_MENU,
  tn as MINUTES,
  on as MINUTES_other,
  sn as MUTE,
  en as MUTED,
  An as NEXT_CAPTION_LANGUAGE,
  an as NEXT_HIT,
  cn as OFF,
  En as ON_TOP,
  Tn as OPEN_ANNOTATION_AT,
  Sn as OPEN_COMPLETED_QUIZ_AT,
  _n as OPEN_QUIZ_AT,
  Rn as PAUSE,
  Nn as PLAY,
  On as PLAYBACK_SPEED,
  In as PLAYBACK_SPEED_MESSAGE,
  Cn as PREVIOUS_CAPTION_LANGUAGE,
  Pn as PREVIOUS_HIT,
  rn as QUALITY,
  un as QUALITY_MENU,
  Un as REPLAY,
  Ln as RESET_PLAYBACK_SPEED,
  yn as RIGHT_ARROW,
  Dn as SEARCH_TRANSCRIPT_PLACEHOLDER,
  ln as SECONDS,
  pn as SECONDS_other,
  Mn as SEEK_BACKWARD,
  kn as SEEK_FORWARD,
  mn as SETTINGS,
  hn as SHORTCUT,
  dn as SIDEBAR,
  Gn as SPACE,
  Yn as SPEED_MENU,
  Vn as START_AUTOSCROLL,
  jn as TOGGLE_CAPTIONS,
  wn as TOGGLE_MUTED,
  gn as TOGGLE_PLAY_PAUSE,
  Kn as TRANSCRIPT_LINES,
  Hn as TRANSCRIPT_LINES_other,
  Fn as TRANSCRIPT_LOADING,
  zn as TRANSCRIPT_LOAD_ERROR,
  Bn as TRANSCRIPT_OPTIONS,
  vn as TRANSCRIPT_RETRY,
  Jn as TRANSCRIPT_UNAVAILABLE,
  fn as UP_ARROW,
  Wn as VIDEO_SETTINGS,
  $n as VOLUME,
  Qn as VOLUME_VALUE,
  bn as default
};
